import React, { useRef, useState } from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import InputPhoneWithDropdown from 'apps/auth/components/form/InputPhoneWithDropdown';
import Form from 'apps/auth/components/form-multi/Form';
import ChangePhoneNumberSmsConfirmModal from 'apps/auth/components/profile/ChangePhoneNumberSmsConfirmModal';
import BasePage from 'apps/auth/components/utils/BasePage';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import { CHANGE_PHONE_NUMBER } from 'apps/auth/constants/formName';
import { AUTH_PROFILE_CHANGE_PHONE_ACTION, AUTH_PROFILE_FIELDS } from 'apps/auth/constants/UrlConstants';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const ChangePhoneNumberPage = () => {
    const { defaultCountry } = useExtra();
    const { fields = {}, submitBtnName = '' } = useForm(CHANGE_PHONE_NUMBER);
    const { headerTitle, profileChangePhoneHeader } = usePageMessages();
    const popupRef = useRef(null);
    const modalRef = useRef(null);
    const [lastFormattedNumber, setLastFormattedNumber] = useState('');

    const submitHandler = (fields, data) => {
        if (data.extra && data.extra.smsConfirmation) {
            modalRef.current?.open(
                <ChangePhoneNumberSmsConfirmModal popupRef={popupRef} modalRef={modalRef} isProfileFlow formattedNumber={lastFormattedNumber} />,
            );
        }
    };

    const setFormattedNumber = (formattedValue) => {
        if (formattedValue) {
            setLastFormattedNumber(formattedValue);
        }
    };

    return (
        <>
            <CommonPage backUrl={AUTH_PROFILE_FIELDS} hasBottomPanel>
                <HeaderPanel title={headerTitle} subtitle={profileChangePhoneHeader} />
                <Form formName={CHANGE_PHONE_NUMBER} field={fields} action={AUTH_PROFILE_CHANGE_PHONE_ACTION} onSubmitHandler={submitHandler}>
                    <InputPhoneWithDropdown
                        field={fields.phone}
                        formName={CHANGE_PHONE_NUMBER}
                        defaultCountry={defaultCountry}
                        iso2={defaultCountry}
                        isNonEditableCountry
                        isProfileFlow
                        popupRef={popupRef}
                        setFormattedNumber={setFormattedNumber}
                    />
                    <FixedBottomPanel isRightAligned>
                        <Button type="submit" raised={true} caption={submitBtnName} />
                    </FixedBottomPanel>
                </Form>
            </CommonPage>
            <PopupNew ref={popupRef} />
            <ModalNew ref={modalRef} />
        </>
    );
};

export default BasePage(ChangePhoneNumberPage);
